'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import classNames from 'classnames';
import appConstants from 'constants/appConstants';

import 'styles/PageSection.scss';


const propTypes = {
    backgroundColor: PropTypes.string,
    backgroundColorClass: PropTypes.string,
    color: PropTypes.string,
    halfSize: PropTypes.bool,
    hideSection: PropTypes.bool,
    link: PropTypes.string,
    id: PropTypes.string,
};

const PageSection = function (props) {
       
    var extraClasses = [];
    var contentContainerClasses = [];
    
    var customStyle = props.backgroundColor ? {backgroundColor:props.backgroundColor, color:props.color ? props.color : "#fff"} : {};
    
    extraClasses.push(props.backgroundColorClass ? props.backgroundColorClass : 'background-color-white');

    if (props.halfSize) {
        extraClasses.push('narrow');
    }

    if (props.hideSection) {
        extraClasses.push('hide');
        customStyle = {display:"none"};
    }

    var classes = classNames(
        'page-section',
        extraClasses
    );

    var containerClasses = classNames(
        'content-container',
        contentContainerClasses
    );

    
    if (props.loading) {
        return (
            <div id={props.id} className="page-section">
                <div className="ps-content hide-content">
                    {props.children}
                </div>
            </div>
        );
    }

    if (props.error) {
        return (
            <div id={props.id} className="page-section">
                <div className="ps-content message">
                    <span>{appConstants.error.PAGE_SECTION.ERROR.format(props.error.toLowerCase())}</span>
                </div>
            </div>
        );
    }

    if (props.text) {
        return (
            <div id={props.id} className="page-section text">
                <div className="ps-content message">
                    <span>{props.text}</span>
                </div>
            </div>
        );
    }

    var content = props.children;

    if (!props.children) {
        return (
            <div className={classes}>{props.text ? props.text : null}</div>
        );
    }

    if (props.link) {
        content = (
            <Link className="link-container" to={props.link} query={props.query}>
                {props.children}
            </Link>
        );
    }

    if (props.onClick) {
        content = (
            <Link className="link-container" to="#" onClick={props.onClick}>
                {props.children}    
            </Link>
        );
    }

    return (
        <div id={props.id} className={classes} style={customStyle}>
            <div className="ps-content show-content">
                {content}
            </div>
        </div>
    );
};

PageSection.propTypes = propTypes;

export default PageSection; 